var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:_vm.className,attrs:{"to":_vm.routerLink,"href":_vm.link},on:{"click":_vm.emitClick}},[(_vm.text)?_c('Txt',{attrs:{"text":_vm.text}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }